import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-path=\"url(#a)\" clip-rule=\"evenodd\"><path d=\"M2.84 5.3a.667.667 0 0 0-.666.667v6.666c0 .369.299.667.667.667h10.667a.667.667 0 0 0 .666-.667V5.967a.667.667 0 0 0-.666-.667zm-2 .667a2 2 0 0 1 2-2h10.668a2 2 0 0 1 2 2v6.666a2 2 0 0 1-2 2H2.84a2 2 0 0 1-2-2z\"></path><path d=\"M5.427 1.886A2 2 0 0 1 6.84 1.3h2.667a2 2 0 0 1 2 2v10.667a.667.667 0 0 1-1.334 0V3.3a.667.667 0 0 0-.666-.667H6.84a.667.667 0 0 0-.667.667v10.667a.667.667 0 1 1-1.333 0V3.3a2 2 0 0 1 .586-1.414\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M.19 0h16v16h-16z\"></path></clipPath></defs>", 2)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })